<template>
  <Layout>
    <template slot="header">
      <DefaultHeader />

      <ProgressBar :progress="progress" />
    </template>

    <nuxt />

    <!-- Hide the default footer -->
    <span slot="footer"></span>
  </Layout>
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader'
import ProgressBar from '@/components/ProgressBar'
import { EventBus, Events } from '@/lib/events'
import Layout from '@/components/Layout'

export default {
  components: { DefaultHeader, ProgressBar, Layout },

  data: () => ({
    progress: 0,
  }),

  mounted() {
    EventBus.$on(Events.StepSetProgress, this.setProgress)
  },

  beforeDestroy() {
    EventBus.$off(Events.StepSetProgress, this.setProgress)
  },

  methods: {
    setProgress(progress) {
      this.progress = progress
    },
  },
}
</script>
